<template>
  <form ref="formRef">
    <div class='reconcile-transaction-overlay col-md-12'>
      <p class="small">Add coding and receipt.</p>
      <div class="overview col-md-12 no-pad">
        <ed-card class="overview-card col-md-12" footer-button="false">
          <div slot="body" class="soft-text">
            <div class="col-md-2">
              <strong>Card number</strong>
              <div>
                <div>
                  *{{ transaction.data.CardNumber }}
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <strong>Card Holder</strong>
              <div>
                <div>
                  {{ transaction.data.Holder }}
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <strong>Merchant</strong>
              <div v-tooltip="transaction.data.Merchant">
                <div class="overflow-merchant">{{ transaction.data.Merchant }}</div>
              </div>
            </div>
            <div class="col-md-2">
              <strong>Date</strong>
              <div>
                <div>{{ formatDate(transaction.data.TransactionDate) }}</div>
              </div>
            </div>
            <div class="col-md-2">
              <strong>Amount</strong>
              <div>
                <v-money currency="USD" locale="en">{{ transaction.data.Amount }}</v-money>
              </div>
            </div>
            <br />
          </div>
        </ed-card>
        <div class="col-md-12" style="margin-top:20px">
          <strong>{{ programName }}</strong>
          <ed-select :placeholder="`Select a ${ programName.toLowerCase() }...`"
                     :options="programLoader.items"
                     track-by="Id"
                     v-model="selectedProgram"
                     :value="selectedProgram"
                     :checkboxes="false"
                     :customLabel="option => option && option.Name ? (option.InternalProgramID ? `${option.Name} (${option.InternalProgramID})` : option.Name) : ''"
                     @open="onSelectProgramOpen"
                     @scroll-bottom="() => loadPrograms(false)"
                     server-search
                     @search="onProgramSearch"
                     name="program"
                     @input="handleProgramInput"
                     :disabled="reconcileAction === 'view' || (reconcileAction !== 'view' && transaction.data.TransactionStatus === 'In Envelope')"
                     v-tooltip="reconcileAction !== 'view' && transaction.data.TransactionStatus === 'In Envelope' ?
                      `This transaction is part of an envelope. You can now only change the ${ programName.toLowerCase() } from the envelope.` : ''"/>
        </div>
        <div class="col-md-12">
          <strong>Supplier</strong>
          <p class="small">Select the EvedPay supplier if applicable</p>
          <ed-select :placeholder="supplierPlaceholder"
                     :options="supplierOptions"
                     v-model="selectedSupplier"
                     :value="selectedSupplier"
                     :checkboxes="false"
                     :customLabel='getLabel'
                     required
                     @open='fetchSuppliersOnOpen'
                     @search="fetchSuppliers"
                     server-search
                     @select="getSelectedSupplier"
                     :disabled="true"
                     class="custom-dropdown-supplier"
                     @input="handleSupplierSelection">
            <template slot='option'
                      slot-scope='props'>
              <ed-select-options thumbnails>
                <div slot='row1' class="option-combo-img">
                  <img slot='image' :src='props.option.Value.Logo' width='48' />
                </div>
                <div slot='row2' class="no-wrap">
                  <span class="option-strong"> <strong>{{ he.decode(props.option.Value.CompanyName) }} </strong> </span>
                  <em class="option-em">({{props.option.Value.Vci}})</em>
                  <br />
                  <span v-if='props.option.Value.SupplierName' class="option-bold"> {{ he.decode(props.option.Value.SupplierName) }}</span>
                  <span v-if='props.option.Value.SupplierRequestedName'>
                    <br />
                    <i>{{ props.option.Value.SupplierRequestedName }}</i>
                  </span>
                  <span v-if='props.option.Value.CountryName'>
                    <br />
                    <span class="fas fa-map-marker-alt contact-icon"></span> &nbsp;{{ props.option.Value.City + (props.option.Value.State != '' && props.option.Value.State != null ? ' ' + props.option.Value.State : (props.option.Value.Region != '' && props.option.Value.Region != null ? ' ' + props.option.Value.Region : '')) + ' ' + props.option.Value.CountryName }}
                  </span>
                  <span v-if='props.option.Value.BusinessType'>
                    <br />
                    <span class="fas fa-briefcase contact-icon"></span> &nbsp;{{ props.option.Value.BusinessType }}
                  </span>
                  <span v-if='props.option.Value.SupplierEmail'>
                    <br />
                    <span class="fas fa-envelope contact-icon">
                    </span> &nbsp;{{ props.option.Value.SupplierEmail }}
                  </span>
                  <br />
                  <span v-if='props.option.Value.IsEvedPay' class="label supplier-evedpay">EvedPay Ready</span>
                  <span v-if='props.option.Value.VendorType' class="label" :class="[`supplier-type-${props.option.Value.VendorType}`]">{{ props.option.Value.VendorType }} Supplier</span>
                </div>
              </ed-select-options>
            </template>
          </ed-select>
          <div class="clear"></div>
        </div>
      </div>
      <div class="col-md-12">
        <strong>Description <span class="optional-text" v-if="!this.requireReceiptDescription">- optional</span></strong>
        <div>
          <textarea v-model="noteText" rows="4" cols="50" maxlength="250" @input="handleTextDescription" :disabled="reconcileAction === 'view'"></textarea>
          <span v-if="fieldsIncomplete.descriptionIncomplete" style="color: red;">Please add a description.</span>
        </div>
      </div>
      <div class="col-md-12">
        <strong>Receipt</strong>
        <br />
        <span style="font-size: 12px;">Accepted formats: pdf, png, jpg, jpeg</span>
        <div>
          <ed-upload button-label='Upload New Receipt'
                     :class='{loading: !uploadFinished}'
                     v-model='attachedFiles'
                     :disabled="isUserAdmin ? false : reconcileAction === 'view'"
                     v-tooltip="(isUserAdmin ? false : reconcileAction === 'view') ? permissionTooltip : ''"
                     readonly
                     :multiple='true'
                     :postAction='api.env + api.$.evedpaycard.receipt'
                     :uploadAuto='true'
                     :canOpenFile='true'
                     @input='createAttachments'
                     :headers='{Authorization: "Bearer " + uploadData.token}'
                     name='attachment_upload'
                     accept='application/pdf, image/png, image/jpeg'
                     extensions='pdf,png,jpg,jpeg'
                     xtarget='transactionAttachment'
                     @open-file='openAttachment'
          >
          </ed-upload>
        </div>
      </div>
      <div class="col-md-12 no-pad" v-if="form">
        <strong>Coding</strong>
        <div class="col-md-12 no-pad">
          <table class="full-width-table">
            <thead>
              <tr>
                <th v-if="reconcileAction !== 'view'"></th>
                <th v-if="hasBu && !hasBuAndCcPair">Business Units</th>
                <th v-if="hasCc && !hasBuAndCcPair">Cost Centers</th>
                <th v-if="hasBuAndCcPair">Bu & Cc</th>
                <th>Category</th>
                <th>Category Ref ID</th>
                <th v-for="(field, index) in form[0]" :key="index">
                  <span v-if="field.Key !== 'Amount'">{{ field.Label }}</span>&nbsp;
                </th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, rowIndex) in form" :key="`form-row-${rowIndex}-${splitCounter}`">
                <td style="border:none; width: 190px" class="split-buttons" v-if="reconcileAction !== 'view'">
                  <a href="javascript:;"
                     class="button row-action"
                     @click="(!selectedProgram || Object.keys(selectedProgram).length === 0) ? showWarningMessage(`Please select a ${programName.toLowerCase()} before adding items`) : toggleSplit(rowIndex)">
                    +Split
                  </a>
                  &nbsp;
                  <a href="javascript:;"
                     class="button row-action"
                     @click="copySplit(rowIndex)">
                    Copy
                  </a>
                  &nbsp;
                  <a href="javascript:;"
                     class="button row-action"
                     @click="pasteSplit(rowIndex)">
                    Paste
                  </a>
                  &nbsp;
                  <a href="javascript:;"
                     v-if="splitCounter > 1"
                     class="button row-action"
                     @click="removeSplit(rowIndex)">
                    Remove
                  </a>
                </td>
                <td v-if="hasBu && !hasBuAndCcPair"
                    v-tooltip="(!selectedProgram || Object.keys(selectedProgram).length === 0) ? `Please select a ${ programName.toLowerCase() } first` :
                            businessUnits.length === 0 ? `Please add Business Units to the selected ${ programName.toLowerCase() } before proceeding` : ''">
                  <ed-select class="borderless"
                             placeholder="Select a BU..."
                             :options="businessUnits"
                             v-model="selectedBu[rowIndex]"
                             :value="selectedBu[rowIndex]"
                             :checkboxes="false"
                             label="name"
                             track-by="businessUnitId"
                             name="bu"
                             :disabled="reconcileAction === 'view' || (!selectedProgram || Object.keys(selectedProgram).length === 0) || businessUnits.length === 0"
                             @input="(option) => handleBUSelection(option, rowIndex)"
                             :style="{ marginBottom: '0' }" />
                </td>
                <td v-if="hasCc && !hasBuAndCcPair"
                    v-tooltip="(!selectedProgram || Object.keys(selectedProgram).length === 0) ? `Please select a ${ programName.toLowerCase() } first` :
                            costCenters.length === 0 ? `Please add Cost Centers to the selected ${ programName.toLowerCase() } before proceeding` : ''">
                  <ed-select class="borderless"
                             placeholder="Select a CC..."
                             :options="costCenters"
                             v-model="selectedCc[rowIndex]"
                             :value="selectedCc[rowIndex]"
                             :checkboxes="false"
                             :custom-label="(o) => `${o.code} (${o.name})`"
                             track-by="costCenterId"
                             name="cc"
                             :disabled="reconcileAction === 'view' || (!selectedProgram || Object.keys(selectedProgram).length === 0) || costCenters.length === 0"
                             @input="(option) => handleCCSelection(option, rowIndex)"
                             :style="{ marginBottom: '0' }" />
                </td>
                <td v-if="hasBuAndCcPair"
                    v-tooltip="(!selectedProgram || Object.keys(selectedProgram).length === 0) ? `Please select a ${ programName.toLowerCase() } first` :
                            buAndCcPairs.length === 0 ? `Please add BUs & CCs to the selected ${ programName.toLowerCase() } before proceeding` : ''">
                  <ed-select class="borderless"
                             placeholder="Select BU & CC..."
                             :options="buAndCcPairs"
                             v-model="selectedBuAndCcPair[rowIndex]"
                             :value="selectedBuAndCcPair[rowIndex]"
                             :checkboxes="false"
                             label="name"
                             track-by="programBusinessUnitAndCostCenterId"
                             name="cc"
                             :disabled="reconcileAction === 'view' || (!selectedProgram || Object.keys(selectedProgram).length === 0) || buAndCcPairs.length === 0"
                             @input="(option) => handleBuAndCcPairSelection(option, rowIndex)"
                             :style="{ marginBottom: '0' }" />
                </td>
                <td v-tooltip="(!selectedProgram || Object.keys(selectedProgram).length === 0) ? `Please select a ${ programName.toLowerCase() } first` :
                            categories.length === 0 ? `Please assign Categories to the ${ divisionName.toLowerCase() } of the selected ${ programName.toLowerCase() } before proceeding` : ''">
                  <ed-select class="borderless"
                             placeholder="Select a Category..."
                             :options="categories"
                             v-model="selectedCategory[rowIndex]"
                             :value="selectedCategory[rowIndex]"
                             :checkboxes="false"
                             label="text"
                             track-by="key"
                             name="category"
                             :disabled="reconcileAction === 'view' || (!selectedProgram || Object.keys(selectedProgram).length === 0) || categories.length === 0"
                             @input="(option) => handleCategorySelection(option, rowIndex)"
                             :style="{ marginBottom: '0' }" />
                </td>
                <td v-tooltip="(!selectedProgram || Object.keys(selectedProgram).length === 0) ? `Please select a ${ programName.toLowerCase() } first` :
                            categories.length === 0 ? `Please assign Categories to the ${ divisionName.toLowerCase() } of the selected ${ programName.toLowerCase() } before proceeding` :
                            !selectedCategory[rowIndex] ? `Please select a category first` : ''">
                  <ed-input class="no-margin borderless"
                            placeholder="Category Ref ID..."
                            v-model="referenceId[rowIndex]"
                            :value="referenceId[rowIndex]"
                            :disabled="reconcileAction === 'view' || (!selectedProgram || Object.keys(selectedProgram).length === 0) || categories.length === 0 || !selectedCategory[rowIndex]"
                            @input="(value) => handleReferenceID(value, rowIndex)"
                            maxlength="50" />
                </td>
                <td v-for="(field) in row">
                  <input v-if="field.Key !== 'Amount' && field.Type !== 'select'"
                         class="custom-fields"
                         type="text" size="1"
                         style="width: 100%; border:none"
                         v-model="field.Values"
                         :placeholder="field.Label"
                         maxlength="200"
                         :disabled="reconcileAction === 'view'">
                  <ed-select v-if="field.Type === 'select'"
                             :placeholder="`${ field.Label }...`"
                             :options="customOptions[field.Key]"
                             track-by="value"
                             v-model="field.Values"
                             :checkboxes="false"
                             label="text"
                             name="program"
                             class="borderless"
                             style="width: 120px; margin: 0" />
                </td>
                <td style="border: none;">
                  <ed-input class="money-input"
                            v-if="splitCounter > 1"
                            amount
                            type="money"
                            style="width: 100px; height: 18px;"
                            v-model="row.Amount"
                            :key="`amount-input-${rowIndex}-${splitCounter}`"
                            @input="handleSplitAmounts"
                            :disabled="reconcileAction === 'view'" />
                  <v-money v-else currency="USD" locale="en">{{ transaction.data.Amount }}</v-money>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <ed-modal title="Caution"
              :show="showAlert"
              @close="showAlert = false, selectedProgram = programConfirmPressed ? programOption : previousSelectedProgram, programConfirmPressed = false"
              @confirm="handleProgramChange(programOption), programConfirmPressed = true"
              :primary-button="'YES'"
              :secondary-button="'NO'">
      <div slot="body">
        <p class="small">Changing the Program will delete all the split items. Are you sure you want to change the program?</p>
      </div>
    </ed-modal>
    <iframe name="transactionAttachment" id="transactionAttachment" class="transaction-attachment" src="about:blank"></iframe>
    <a @click="closeAttachment" class="close-attachment-button"><i class="fa fa-times-circle"></i></a>
  </form>
</template>

<script>
import he from 'he'
import { EventBus } from '@/event-bus'

export default {

  data() {
    return {
      programs: [],
      noteText: '',
      suppliers: [],
      newReconcile: {},
      selectedSupplier: Object,
      selectedProgram: null,
      supplierOptions: [],
      programOptions: [],
      splitCounter: 1,
      mediaFilesPath: '',
      form: null,
      requireReceiptDescription: false,
      attachedPath: [],
      uploadData: {
        token: this.$user.sessionSettings.Token
      },
      splitAmounts: this.transaction.data.Amount,
      attachedFiles: [],
      transactionFiles: [],
      businessUnits: [],
      costCenters: [],
      buAndCcPairs: [],
      categories: [],
      selectedBu: [],
      selectedCc: [],
      selectedBuAndCcPair: [],
      selectedCategory: [],
      referenceId: [],
      programName: '',
      divisionName: '',
      loadedCategoriesAndBuAndCc: -1,
      hasBu: false,
      hasCc: false,
      hasBuAndCcPair: false,
      showAlert: false,
      programOption: Object,
      previousSelectedProgram: Object,
      programConfirmPressed: false,
      copySplitObject: {},
      customOptions: {},
      baseCustomFields: null,
      uploadFinished: true,
      programLoader: {
        items: [],
        pageIndex: 0,
        hasMore: true,
        isLoading: false,
        searchTerm: ''
      }
    }
  },

  props: {
    transaction: Object,
    fieldsIncomplete: Object,
    reconcileAction: 'create'
  },

  beforeCreate() {
    this.he = he
  },

  async created() {
    try {
      let row = this.transaction.data

      if (row.ProgramId) {
        this.selectedProgram = {
          Id: row.ProgramId,
          Name: row.ProgramName,
          InternalProgramID: row.InternalProgramID
        }

        this.getCategoriesAndBuAndCc(row.ProgramId)
      }

      if (row.Supplier || row.NonEvedSupplier) {
        let supplierName = row.Supplier ? `${row.Supplier} (#${row.SupplierEoNumber})` : row.NonEvedSupplier
        this.selectedSupplier = {
          Key: row.VendorId,
          Value: {
            CompanyName: supplierName,
            VendorId: row.SupplierId || -row.SupplierNetworkId
          }
        }
      }

      await this.getReconcile(row)

      this.programName = this.singularize(this.$root.getUser.settings.Labels.ProgramLabel)
      this.divisionName = this.singularize(this.$root.getUser.settings.Labels.DivisionName)

      this.hasBu = this.$root.getUser.settings.HasBusinessUnit
      this.hasCc = this.$root.getUser.settings.HasCostCenter
      this.hasBuAndCcPair = this.$root.getUser.settings.UseBusinessUnitAndCostCenterMapping
      this.hasBuOrCcOrPair = this.hasBu || this.hasCc || this.hasBuAndCcPair

      this.$emit('split-amounts', this.splitAmounts)
    } catch (error) {
      console.error('Error during component initialization:', error)
      throw error
    }
  },

  computed: {
    supplierPlaceholder() {
      let row = this.transaction.data
      return row.Merchant ? row.Merchant : 'Select a supplier...'
    },
    isUserAdmin() {
      if (this.$user.$.userPermissions.includes('EvedPayCardAdministrator')) {
        return true
      }
      return false
    },
    permissionTooltip() {
      return 'You do not have permission to change receipt attachments on this transaction.'
    }
  },

  methods: {
    async getCustomOptions(url, key) {
      try {
        const response = await this.api.get(url)
        if (response && response.data) {
          this.customOptions[key] = response.data
        }
      } catch (error) {
        console.error(error)
      }
    },

    openAttachment(data) {
      const frame = window.document.getElementById('transactionAttachment')
      data.e.preventDefault()

      if (data.file.type === 'application/pdf') {
        frame.removeAttribute('srcdoc')
        frame.src = data.path
      } else {
        frame.srcdoc = `<style>embed {width: 99%}</style><embed src="${data.path}" type=${data.file.type} />`
      }
      frame.classList.add('open')
      EventBus.$emit('openAttachment')
    },
    closeAttachment() {
      window.document.getElementById('transactionAttachment').classList.remove('open')
      window.document.getElementById('transactionAttachment').removeAttribute('srcdoc')
      EventBus.$emit('closeAttachment')
    },

    createAttachments(e) {
      e.forEach(x => {
        var parts = x.name.split('.')
        var extension = ''
        if (parts.length > 1) {
          extension = parts[parts.length - 1]
        }
        if (!['pdf', 'png', 'jpg', 'jpeg'].includes(extension.toLowerCase())) {
          this.attachedFiles = this.attachedFiles.filter(x => x.success)
          this.showWarningMessage(`The file "${x.name}" is not compatible. Please upload files with one of the following extensions: .pdf, .png, .jpg, .jpeg`)
          return
        }

        const MAX_FILE_SIZE = 10 * 1024 * 1024 // 10 MB
        if (x.size >= MAX_FILE_SIZE) {
          this.attachedFiles = this.attachedFiles.filter(x => x.size <= MAX_FILE_SIZE)
          this.showWarningMessage(`The file "${x.name}" is too large. Please upload files smaller than 10 MB.`)
          return
        }
      })
      let completedFiles = e.filter(
        item => item.success || // files uploaded with success
          (!item.success && item.response && typeof item.response === 'string' && !this.isJson(item.response)) // files where requested failed
      )

      if (completedFiles.length === e.length) {
        this.uploadFinished = true
        this.$emit('uploadFinished', this.uploadFinished)

        let attachments = e.map((item) => {
          let uploadError = ''
          let itemResponse = null
          let clientDataPath = ''
          let mediaFile = ''

          if (item.success && item.response) {
            itemResponse = JSON.parse(item.response)
            if (itemResponse.success) {
              const regex = /(ClientData\/.*)/
              const match = itemResponse.path.match(regex)
              if (match && match.length > 1) {
                const filePath = match[1]
                clientDataPath = filePath.substring(filePath.indexOf('ClientData'))
                this.attachedPath.push(clientDataPath)
                const splits = clientDataPath.split('/')
                mediaFile = splits[splits.length - 1]
              } else {
                console.log('No matching files.')
              }
            }
            uploadError = (itemResponse && itemResponse.uploadError) ? itemResponse.uploadError : ''
          }
          if (!item.success) {
            uploadError = 'Upload request failed'
          }

          if (this.reconcileAction !== 'create' && !item.response) {
            const splits = item.path.split('/')
            mediaFile = splits[splits.length - 1]
          }

          const vendorId = this.$root.getUser.$.data.VendorID
          const VCI = this.$root.getUser.$.data.VCI

          if (uploadError) {
            this.showWarningMessage('File "' + item.name + '": ' + uploadError)
          } else {
            return {
              OriginalName: item.name,
              SizeBytes: item.size,
              MediaFile: item.mediaFile ? item.mediaFile : mediaFile || '',
              AttachmentFile: itemResponse ? itemResponse.file : (item.file || ''),
              Id: item.id ? item.id : '',
              PathWithName: item.pathWithName ? item.pathWithName : itemResponse ? clientDataPath : '',
              FullPath: item.path ? item.path : itemResponse.path ? itemResponse.path : '',
              ReadOnly: item.readonly || false,
              VendorId: vendorId,
              VCI: VCI
            }
          }
        })

        this.mediaFilesPath = this.attachedPath.join(', ')
        this.$emit('mediaFilesPathUpdated', this.mediaFilesPath)
        this.attachedPath = []

        try {
          this.attachedFiles = this.attachedFiles.filter(item =>
            item.success &&
            (
              (!item.response && item.name) || // take existing items from edit
              (JSON.parse(item.response).success) // take new added items
            )
          ).map(item => {
            if (item.response) {
              const response = JSON.parse(item.response)
              if (response.path) {
                item.path = response.path // assign the 'path' property from the response to the item
              }
            }
            return item
          })
        } catch (ee) {
          console.error(ee)
        }
        const filteredAttachments = attachments.filter(item => item)
        this.$emit('attachmentsUpdated', filteredAttachments)
        this.$emit('uploadFinished', this.uploadFinished)
        return filteredAttachments
      } else {
        this.uploadFinished = false
        this.$emit('uploadFinished', this.uploadFinished)
      }
    },

    isJson(str) {
      try {
        JSON.parse(str)
      } catch (e) {
        return false
      }
      return true
    },

    singularize(value) {
      return value.endsWith('s') ? value.slice(0, -1) : value
    },

    populateFiles() {
      if (this.transactionFiles.length > 0) {
        this.transactionFiles.forEach((file) => {
          var parts = file.OriginalName.split('.')
          var extension = ''
          var fileType = ''
          if (parts.length > 1) {
            extension = parts[parts.length - 1].toLowerCase()
          }
          switch (extension) {
            case 'png':
              fileType = 'image/png'
              break
            case 'pdf':
              fileType = 'application/pdf'
              break
            case 'jpg':
              fileType = 'image/jpg'
              break
            case 'jpeg':
              fileType = 'image/jpeg'
              break
            default:
              fileType = ''
          }
          this.attachedFiles.push({
            name: file.OriginalName,
            type: fileType,
            size: file.SizeBytes,
            file: file.MediaFile,
            mediaFile: file.MediaFile,
            path: file.FullPath,
            pathWithName: file.PathWithName,
            id: file.Id,
            success: true,
            readonly: this.reconcileAction === 'view' && !this.isUserAdmin
          })
        })
        const attachments = this.attachedFiles.map(item => ({
          OriginalName: item.name,
          SizeBytes: item.size,
          MediaFile: item.mediaFile,
          AttachmentFile: item.file,
          PathWithName: item.pathWithName,
          FullPath: item.path,
          ReadOnly: item.readonly || false,
          Id: item.id
        }))
        const filteredAttachments = attachments.filter(item => item)
        this.$emit('attachmentsUpdated', filteredAttachments)
      }
    },

    setRowFieldsValues(fieldsValues) {
      if (this.loadedCategoriesAndBuAndCc === 0) {
        setTimeout(() => {
          this.setRowFieldsValues(fieldsValues)
        }, 100)
        return
      }
      this.loadedCategoriesAndBuAndCc = -1

      var existingRow = this.form[0]

      while (this.form.length < fieldsValues.length) {
        const newRow = existingRow.map((field) => ({ Key: field.Key, Label: field.Label, Values: field.Values, Required: field.Required, Type: field.Type }))
        this.form.push(newRow)
        this.splitCounter++
      }

      if (this.hasBuAndCcPair) {
        this.selectedBuAndCcPair = new Array(fieldsValues.length).fill(null)
      }
      if (this.hasBu) {
        this.selectedBu = new Array(fieldsValues.length).fill(null)
      }
      if (this.hasCc) {
        this.selectedCc = new Array(fieldsValues.length).fill(null)
      }
      this.selectedCategory = new Array(fieldsValues.length).fill(null)
      this.referenceId = new Array(fieldsValues.length).fill(null)

      fieldsValues.forEach((r, index) => {
        this.$set(this.form[index], 'Amount', r.Amount)
        this.form[index].ItemId = r.ItemId
        r.CustomFields.forEach(field => {
          this.form[index].forEach(f => {
            if (f.Key === field.FieldId) {
              if (f.Type === 'select') {
                const matchedOption = this.customOptions[f.Key].find(x => x.text === field.Value)
                if (matchedOption) {
                  this.$set(f, 'Values', matchedOption)
                }
              } else {
                f.Values = this.transaction && this.transaction.data && this.transaction.data.ReconcileId ? field.Value : f.Values
              }
            }
          })
        })

        if (this.hasBuAndCcPair) {
          if (r.ProgramBusinessUnitAndCostCenter && r.ProgramBusinessUnitAndCostCenter.Id) {
            this.selectedBuAndCcPair[index] = this.buAndCcPairs.find(pair => pair.programBusinessUnitAndCostCenterId === r.ProgramBusinessUnitAndCostCenter.Id.toString())
          }
        } else {
          if (r.BusinessUnit && r.BusinessUnit.Id) {
            this.selectedBu[index] = this.businessUnits.find(bu => bu.businessUnitId === r.BusinessUnit.Id.toString())
          }
          if (r.CostCenter && r.CostCenter.Id) {
            this.selectedCc[index] = this.costCenters.find(cc => cc.costCenterId === r.CostCenter.Id.toString())
          }
        }
        if (r.CategoryId) {
          this.selectedCategory[index] = this.categories.find(c => c.key === r.CategoryId.toString())
          this.referenceId[index] = r.ReferenceId
        }
      })

      this.handleSplitAmounts()
      this.emitReconcileData()
    },

    toggleSplit(index) {
      const existingRow = this.form[index]

      // Initialize Amount as 0 if the split hasn't occurred
      if (this.form.length < 2) {
        this.$set(this.form[index], 'Amount', 0)
      }

      // Clone the existing row fields
      const newRow = existingRow.map(field => ({
        Key: field.Key,
        Label: field.Label,
        Values: '', // Reset Values
        Required: field.Required,
        Type: field.Type
      }))

      this.baseCustomFields.forEach((baseObj, baseIndex) => {
        if (newRow[baseIndex]) {
          Object.keys(baseObj).forEach((key) => {
            newRow[baseIndex][key] = baseObj[key]
          })
        }
      })

      // Force reactivity
      this.$set(newRow, 'Amount', 0)

      // Add the new row in the form
      this.form.splice(index + 1, 0, newRow)
      if (this.hasBuAndCcPair) {
        this.selectedBuAndCcPair.splice(index + 1, 0, null)
      }
      if (this.hasBu) {
        this.selectedBu.splice(index + 1, 0, null)
      }
      if (this.hasCc) {
        this.selectedCc.splice(index + 1, 0, null)
      }
      this.selectedCategory.splice(index + 1, 0, null)
      this.referenceId.splice(index + 1, 0, null)

      this.$nextTick(() => {
        this.handleSplitAmounts()
      })

      this.splitCounter++
      this.emitReconcileData()
    },

    removeSplit(index) {
      if (this.form.length > 1) {
        this.form.splice(index, 1)
        if (this.hasBuAndCcPair) {
          this.selectedBuAndCcPair.splice(index, 1)
        }
        if (this.hasBu) {
          this.selectedBu.splice(index, 1)
        }
        if (this.hasCc) {
          this.selectedCc.splice(index, 1)
        }
        this.selectedCategory.splice(index, 1)
        this.referenceId.splice(index, 1)
        this.splitCounter--
        this.handleSplitAmounts()
        this.emitReconcileData()
        this.$forceUpdate()
      }
    },

    copySplit(index) {
      if (this.form.length > 0) {
        this.copySplitObject.Amount = this.form[index].Amount
        this.copySplitObject.Fields = Array.from(this.form[index])
        if (this.hasBuAndCcPair) {
          this.copySplitObject.SelectedBuAndCcPair = this.selectedBuAndCcPair[index]
        }
        if (this.hasBu) {
          this.copySplitObject.SelectedBu = this.selectedBu[index]
        }
        if (this.hasCc) {
          this.copySplitObject.SelectedCc = this.selectedCc[index]
        }
        this.copySplitObject.SelectedCategory = this.selectedCategory[index]
        this.copySplitObject.ReferenceId = this.referenceId[index]
      }
    },

    pasteSplit(index) {
      if (this.form.length > 0) {
        this.form[index].Amount = this.copySplitObject.Amount
        this.copySplitObject.Fields.forEach(field => {
          let matchingField = this.form[index].find(f => f.Key === field.Key)
          if (matchingField) {
            matchingField.Values = field.Values
          }
        })
        if (this.hasBuAndCcPair) {
          this.selectedBuAndCcPair[index] = this.copySplitObject.SelectedBuAndCcPair
        }
        if (this.hasBu) {
          this.selectedBu[index] = this.copySplitObject.SelectedBu
        }
        if (this.hasCc) {
          this.selectedCc[index] = this.copySplitObject.SelectedCc
        }
        this.selectedCategory[index] = this.copySplitObject.SelectedCategory
        this.referenceId[index] = this.copySplitObject.ReferenceId
        this.handleSplitAmounts()
        this.emitReconcileData()
        this.$forceUpdate()
      }
    },

    resetSplit() {
      this.selectedBu = []
      this.selectedCc = []
      this.selectedBuAndCcPair = []
      this.selectedCategory = []
      this.referenceId = []
      this.form = [this.form[0]]
      this.splitCounter = 1
      if (this.hasBuAndCcPair) {
        this.selectedBuAndCcPair = new Array(1).fill(null)
      }
      if (this.hasBu) {
        this.selectedBu = new Array(1).fill(null)
      }
      if (this.hasCc) {
        this.selectedCc = new Array(1).fill(null)
      }
      this.selectedCategory = new Array(1).fill(null)
      this.referenceId = new Array(1).fill(null)
      this.handleSplitAmounts()
      this.emitReconcileData()
      this.$forceUpdate()
    },

    formsTemplate() {
      if (typeof this.transaction === 'object' && this.transaction !== null) {
        if (!this.transaction.hasOwnProperty('form')) {
          this.transaction.form = JSON.parse(JSON.stringify(this.form))
        }
      }
    },

    async getCategoriesAndBuAndCc(programId) {
      this.loadedCategoriesAndBuAndCc = 0

      const response = await this.api.get(this.api.$.evedpaycard.categoriesAndBuAndCc, {
        params: {
          programId: programId,
          invoiceId: 0,
          loadAllData: true
        }
      })

      if (response && response.data) {
        if (response.data.costCentersAndBusinessUnit) {
          this.hasBuAndCcPair = response.data.costCentersAndBusinessUnit.areCombined || this.$root.getUser.settings.UseBusinessUnitAndCostCenterMapping
          if (this.hasBuAndCcPair) {
            if (response.data.costCentersAndBusinessUnit.mixedCostCentersAndBusinessUnits) {
              this.buAndCcPairs = response.data.costCentersAndBusinessUnit.mixedCostCentersAndBusinessUnits
            }
          } else {
            this.hasBu = response.data.costCentersAndBusinessUnit.businessUnits.length > 0 || this.$root.getUser.settings.HasBusinessUnit
            this.hasCc = response.data.costCentersAndBusinessUnit.costCenters.length > 0 || this.$root.getUser.settings.HasCostCenter
            if (this.hasBu) {
              this.businessUnits = response.data.costCentersAndBusinessUnit.businessUnits
            }
            if (this.hasCc) {
              this.costCenters = response.data.costCentersAndBusinessUnit.costCenters
            }
          }
        }
        if (response.data.categories) {
          this.categories = response.data.categories
        }

        this.loadedCategoriesAndBuAndCc = 1
      }
    },

    onSelectProgramOpen() {
      this.programLoader.searchTerm = ''
      this.loadPrograms(true)
    },

    async loadPrograms(reset = false) {
      const loader = this.programLoader
      if (loader.isLoading) return

      if (reset) {
        loader.pageIndex = 0
        loader.items = []
        loader.hasMore = true
      }
      if (!loader.hasMore) return

      loader.isLoading = true
      try {
        const { data } = await this.api.get(
          this.api.$.evedpaycard.programs,
          {
            params: {
              divisionId: this.transaction.data.DivisionId,
              pageIndex: loader.pageIndex,
              pageSize: this.pageSize,
              searchTerm: loader.searchTerm
            }
          }
        )

        const { Items, HasMore } = data

        const mapped = Items.map(p => ({
          Id: p.ProgramId,
          Name: p.ProgramName,
          InternalProgramID: p.InternalProgramID
        }))

        loader.items = reset
          ? mapped
          : loader.items.concat(mapped)
        loader.hasMore = HasMore
        loader.pageIndex += 1

        this.programOptions = loader.items
      } catch (e) {
        console.error('loadPrograms error', e)
      } finally {
        loader.isLoading = false
      }
    },

    onProgramSearch(term) {
      this.programLoader.searchTerm = term
      this.loadPrograms(true)
    },

    async getReconcile(row) {
      this.programs = []
      const response = await this.api.get('evedpaycards/transactions/get-reconcile', {
        params: {
          transactionId: row.Id,
          divisionId: row.DivisionId
        }
      })

      if (response && response.data) {
        this.noteText = response.data.ReconcileNote
        this.requireReceiptDescription = response.data.RequireReceiptDescription
        this.handleTextDescription()

        this.transactionFiles = response.data.TransactionFiles
        this.populateFiles()

        const form = response.data.Form
        this.formKey = form.Key
        if (form.Fieldsets && form.Fieldsets.length > 0) {
          this.form = [form.Fieldsets[0].Fields]
          this.baseCustomFields = JSON.parse(JSON.stringify(form.Fieldsets[0].Fields))
        } else {
          this.form = [[]]
          this.baseCustomFields = [[]]
        }
        this.$emit('fields-updated', { fields: this.form, formKey: this.formKey })
        this.formsTemplate()

        for (const x of this.form[0]) {
          if (x.Type === 'select') {
            this.$set(this.customOptions, x.Key, [])
            if (x.DataSource && x.DataSource.Url) {
              await this.getCustomOptions(x.DataSource.Url, x.Key)
            }
          }
        }

        this.setRowFieldsValues(response.data.TransactionFields)
      }
    },

    fetchSuppliersOnOpen() {
      this.suppliers.length || this.api.get(this.api.$.evedpaycard.suppliers, {
        params: {
          q: ''
        }
      })
        .then(r => {
          if (r && r.data) {
            this.supplierOptions = r.data
            this.originalSuppliers = r.data
          }
        })
        .catch(e => console.warn(e))
    },

    async fetchSuppliers(query) {
      let results = await this.api.get(this.api.$.evedpaycard.suppliers, {
        params: {
          q: query || ''
        }
      })

      if (results && results.data) {
        this.supplierOptions = results.data
      }
    },

    getSelectedSupplier(e) {
      this.selectedSupplier = e.Value.VendorId
    },

    getLabel(option) {
      if (Object.keys(option).length > 0) {
        return option.Value.CompanyName + (option.Value.Vci ? ' (#' + option.Value.Vci + ')' : '')
      }
    },

    handleSplitAmounts() {
      this.form.forEach(item => {
        const parsedAmount = item.Amount && this.form.length !== 1
          ? parseFloat(item.Amount)
          : (this.form.length === 1 ? parseFloat(this.transaction.data.Amount) : 0)

        // Ensure the amount is set reactively
        if (!isNaN(parsedAmount)) {
          this.$set(item, 'Amount', parsedAmount)
        }
      })

      // Make sure the split amounts are updated and Vue re-renders
      this.splitAmounts = this.form.map(item => item.Amount)
      this.$forceUpdate()  // Force Vue to update the DOM
      this.$emit('split-amounts', this.splitAmounts)
    },

    handleTextDescription() {
      const data = {
        noteText: this.noteText,
        requireReceiptDescription: this.requireReceiptDescription
      }

      this.$emit('description-text', data)
      this.fieldsIncomplete.descriptionIncomplete = false
    },

    handleSupplierSelection(option) {
      this.selectedSupplier = option
      this.emitReconcileData()
    },

    handleProgramChange(option) {
      this.selectedProgram = option !== null ? option : Object
      this.resetSplit()
      if (option && option.Id) {
        this.getCategoriesAndBuAndCc(option.Id)
      }
      this.emitReconcileData()
    },

    handleProgramInput(option) {
      if (this.previousSelectedProgram && option && this.previousSelectedProgram.Id === option.Id) {
        this.handleProgramChange(option)
        return
      }

      this.programOption = option
      if (Object.keys(this.previousSelectedProgram).length !== 0 && this.previousSelectedProgram && this.previousSelectedProgram.Id && this.previousSelectedProgram.Name) {
        this.showAlert = true
      } else {
        this.handleProgramChange(option)
      }
    },

    handleBUSelection(option, rowIndex) {
      this.selectedBu[rowIndex] = option
      this.emitReconcileData()
    },

    handleCCSelection(option, rowIndex) {
      this.selectedCc[rowIndex] = option
      this.emitReconcileData()
    },

    handleBuAndCcPairSelection(option, rowIndex) {
      this.selectedBuAndCcPair[rowIndex] = option
      this.emitReconcileData()
    },

    handleCategorySelection(option, rowIndex) {
      this.selectedCategory[rowIndex] = option
      this.referenceId[rowIndex] = option && option.referenceId ? option.referenceId : null
      this.emitReconcileData()
    },

    handleReferenceID(value, rowIndex) {
      this.referenceId[rowIndex] = value
      this.emitReconcileData()
    },

    emitReconcileData() {
      const data = {
        itemIds: this.form.map(item => item.ItemId),
        splitCounter: this.splitCounter,
        selectedSupplier: this.selectedSupplier !== null ? this.selectedSupplier : Object,
        selectedProgram: this.selectedProgram !== null ? this.selectedProgram : Object,
        selectedCategory: this.selectedCategory.map(x => x && x.key),
        referenceId: this.referenceId !== null ? this.referenceId : '',
        fields: this.form
      }
      if (this.hasBuAndCcPair) {
        data.selectedBu = this.selectedBuAndCcPair.map(x => x && parseInt(x.businessUnitId, 10))
        data.selectedCc = this.selectedBuAndCcPair.map(x => x && parseInt(x.costCenterId, 10))
        data.selectedBuAndCcPair = this.selectedBuAndCcPair.map(x => x && parseInt(x.programBusinessUnitAndCostCenterId, 10))
      } else {
        if (this.hasBu) {
          data.selectedBu = this.selectedBu.map(x => x && parseInt(x.businessUnitId, 10))
        }
        if (this.hasCc) {
          data.selectedCc = this.selectedCc.map(x => x && parseInt(x.costCenterId, 10))
        }
      }

      this.$emit('reconcile-created', data)
    },

    formatDate: function (date) {
      const momentDateFormat = this.$root.getUser.sessionSettings.DateAndTimeFormats.MomentDateFormat
      return global.moment(date).format(momentDateFormat)
    },

    showWarningMessage(message) {
      this.$nextTick(() => {
        this.$notifications.notify({
          type: 'plain',
          icon: 'exclamation-circle',
          placement: { from: 'top', align: 'center' },
          timeout: 0,
          message: message,
          discard: 'Ok',
          goto: ''
        })
      })
    }
  }
}
</script>

<style lang='scss' scoped>
@import "~@/assets/sass/_variables.scss";

.borderless >>> {
  input.form-control {
    border-top: none;
    border-bottom: none;
    border-right: none;
  }
  .dawnSelect {
    border-top: none;
    border-bottom: none;
  }
  .dawnSelect__content-wrapper {
    min-width: 340px;
  }
}
.money-input {
  margin-top: -3px;
  &, >>> input {
    height: 36px;
  }
}
.split-button {
  position: relative;
  left: -5px;
}

.reconcile-transaction-overlay {
  background-color: white;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.full-width-table {
  width: 100%;
  margin: 0px;
  padding: 0;
}

.full-width-table th {
  border: none;
}

.full-width-table td {
  padding: 0px !important;
  border: 1px solid #ccc; 
  margin: 0px !important;
  font-size: 15px;
}

.overview .overview-card {
  width: 100%;
  min-height: 0;
  margin: 0;
  padding: 0;
  padding-bottom: 10px;
}

.overflow-merchant {
  text-overflow: ellipsis;
  overflow: hidden;
}

.optional-text {
  font-style: italic;
  opacity: 0.6;
}

.btn-custom {
  background-color: white !important;
  color: blue;
  border: 2px solid blue;
  border-radius: 5px;
  padding: 10px 20px;
  font-size: 15px;
  cursor: pointer;
}

.btn-custom:hover {
  background-color: white;
  color: blue;
}

// List entry
.option {
  &-combo-img {
    width: 48px;
    margin: 5px 10px 5px 2px;
    display: block;
    float: left;
  }
  &-bold {
    display: inline-block;
    width: 85%;
    max-width: 87%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: bold;
  }
  &-em {
    font-weight: $font-weight-bold;
    float: right;
    @include theme {
    color: v(primary-05);
    }
  }
  &-strong {
    display: inline-block;
    width: 85%;
    max-width: 87%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    @include theme {
    color: v(primary-05);
    }
  }
}

// Card entry
.supplier {
  &-txt {
    width: 60%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  &-strong {
    max-width: 80%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    @include theme {
    color: v(primary-05);
    }
  }
  &-em {
    font-size: 15px;
    font-weight: $font-weight-bold;

    margin-top: 3px;
    display: inline-block;
    position: absolute;
    right: 40px;

    @include theme {
    color: v(primary-05);
    }
  }
  &-details[class] {
    width: 100%;
    height: 190px;

    .status-label {
      margin-top: 10px;
    }
  }
  &-img {
    height: 90px;
    width: 90px;
    margin: 5px 10px 5px 2px;
    display: block;
    float: left;
  }
  &-evedpay{
    @include theme {
    color: v(canvas);
    background-color: #009FCC;
    border-color: #009FCC;
    }
  }
  &-not-evedpay{
    @include theme {
    color: v(canvas);
    background-color: #e02630;
    border-color: #e02630;
    }
  } 
  &-type-preferred {
    @include theme {
    color: v(canvas);
    background-color: #009FCC;
    border-color: #009FCC;
    }
  }
  &-type-approved {
    @include theme {
    color: v(canvas);
    background-color: #75A628;
    border-color: #75A628;
    }
  }
  &-type-pending {
    color: #666666;
    background-color: #FFFFFF;
    border-color: #666666;
  }
  &-default-status {
    color: #666666;
    background-color: #FFFFFF;
    border-color: #666666;
  }
}

td input.custom-fields::placeholder {
  color: white;
}

.custom-dropdown-supplier >>> input[disabled]::placeholder {
  color: #333333;
}

.label {
  text-transform: capitalize;
}
.supplier-txt .label {
  height: 20px;
}

.contact-icon {
  @include theme {
    color: v(tertiary-01);
  }
}
.close-attachment-button {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 100;
  cursor: pointer;
  color: #000 !important;
  display: none;
  font-size: 1.5em;
}
.transaction-attachment.open + .close-attachment-button {
  display: block;
}

.transaction-attachment.open + .close-attachment-button {
  display: block;
}
.transaction-attachment {
  border: 0;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100vh);
  display: none;
  z-index: 99;
  background: #fff;

  &.open {
    display: block;
  }
}

.overview-card >>> .dawn-card-footer {
  display: none;
}

a.row-action {
  text-decoration: underline;
}

</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-transactions/ReconcileTransaction.vue